export {default as authData} from "./auth-data";
export * from "./auth-data";
